import { useState } from 'react';

import { StateSetter } from './common';

export class NullableStateCell<T> {
  public readonly value: T | null;
  public readonly setValue: StateSetter<T | null>;

  constructor() {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    [this.value, this.setValue] = useState<T | null>(null);
  }

  public hasValue(): boolean {
    return this.value !== null;
  }

  public isEmpty(): boolean {
    return !this.hasValue();
  }

  public forceValue(): T {
    if (this.value === null) {
      throw new Error('No value in cell');
    }
    return this.value;
  }

  public clear(): void {
    this.setValue(null);
  }

  public forceValueAndClear(): T {
    const value = this.forceValue();
    this.clear();
    return value;
  }
}

export const useNullableState = <T>(): NullableStateCell<T> =>
  new NullableStateCell();
